import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const HowItWorks = () => {
  const { content } = useLanguage();
  const { howItWorksSteps, ui } = content;

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {ui.howItWorks.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            {ui.howItWorks.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {howItWorksSteps.map((step, index) => (
            <div
              key={step.id}
              className="relative group"
            >
              {/* Connector line (hidden on mobile, shown on desktop) */}
              {index < howItWorksSteps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-600 to-gray-800 -z-10"></div>
              )}

              {/* Card */}
              <div className="bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl p-8 hover:border-blue-600/50 transition-all duration-300 h-full">
                {/* Step number */}
                <div className="text-6xl font-bold text-blue-600/20 mb-4">
                  {step.number}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Visual Flow */}
        <div className="mt-16 p-8 bg-gray-950 border border-gray-800 rounded-3xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center">
            {ui.howItWorks.flow.map((step, index) => (
              <React.Fragment key={step.title}>
                <div className="flex-1">
                  <div className="text-2xl font-bold text-white mb-2">{step.title}</div>
                  <div className="text-sm text-gray-500">{step.subtitle}</div>
                </div>

                {index < ui.howItWorks.flow.length - 1 && (
                  <div className="hidden md:block text-blue-600">
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
